import React, { Component } from "react";
import $ from "jquery";
import { AiFillSave } from "react-icons/ai";
import LoanInformation from "../../MyFiles/1500.jpg";

class Refahi extends Component {
  constructor(props) {
    super(props);
    //console.log("APP-Constructor Refahi", this.props.userRequestJson);
    props.getLoanReason();
    props.getUserLoanInfo();
  }

  state = {
    errorMessage: "",
    amount: 0,
    isRegister: true,
  };
  componentDidMount() {
    this.props.getUserLoanRequest();
  }
  toggleRegister = () => {
    this.setState({ isRegister: !this.state.isRegister });
  };
  thosandSeprator = (e) => {
    if (e !== null && e > 0) {
      return e.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      return e;
    }
  };
  HandleAmount = (el) => {
    var element = $("#" + el);
    var amount = $(element).val();
    amount = amount.toString().replace(/,/g, "");
    if (parseInt(amount) >= parseInt(this.props.userLoanInfoJson.amount)) {
      var val = this.props.userLoanInfoJson.amount;
      var e = "۰".charCodeAt(0);
      var NewVal = val.replace(/[۰-۹]/g, function(t) {
        return t.charCodeAt(0) - e;
      });
      // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
      e = "٠".charCodeAt(0);
      NewVal = NewVal.replace(/[٠-٩]/g, function(t) {
        return t.charCodeAt(0) - e;
      });
      NewVal = NewVal.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
      var parts = NewVal.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      $(element).val(parts.join("."));
    }
  };
  RemoveSeprator = (e) => {
    var element = $("#" + e);
    if (element !== null) {
      var amount = $(element).val();
      $(element).val(amount.toString().replace(/,/g, ""));
    }
  };
  thosandSepratorBlur = (el) => {
    var element = $("#" + el);
    if (element !== null) {
      var amount = $(element).val();
      var val = amount.replace(/,/g, "");
      var e = "۰".charCodeAt(0);
      var NewVal = val.replace(/[۰-۹]/g, function(t) {
        return t.charCodeAt(0) - e;
      });
      // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
      e = "٠".charCodeAt(0);
      NewVal = NewVal.replace(/[٠-٩]/g, function(t) {
        return t.charCodeAt(0) - e;
      });
      NewVal = NewVal.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
      var parts = NewVal.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      $(element).val(parts.join("."));
    }
  };
  HandleSeprator = (e) => {
    e = e.toString().replace(/,/g, "");
    return e;
  };
  handleFileSelect = (el) => {
    var evt = document.getElementById(el);
    if (evt.files && evt.files.length > 0) {
      var item = $(evt).parent();
      $(item)
        .addClass("bg-success")
        .removeClass("bg-danger");
      $("label[for=" + evt.id + "]").text("انتخاب شد");
      //var res = $(item).next().find('label').text();
      //console.log(evt.target.id);
    }
  };
  render() {
    const listLoanReasonItems_Active = this.props.userLoanReason.map(
      (myList) => (
        <option key={myList.ID} value={myList.ID}>
          {myList.Title}
        </option>
      )
    );
    const myRequest = this.props.userLoanRequestJson.map((e) => (
      <li key={e.ID} className={"Array-item readClass"}>
        <span className="wp-text-small rounded p-1">
          تاریخ درخواست {e.RequestTime}
        </span>
        <div className="title mt-2">
          مبلغ درخواستی: <strong>{e.Amount_Request}</strong>
        </div>
        <div className="d-grid mb-2">
          {/* <span className="text-danger px-2 py-1 wp-text">
            سقف مجاز: <strong>{e.Amount_Maximum}</strong>{" "}
          </span> */}
          <span className="px-2 py-1 wp-text">
            پست سازمانی: <b>{e.Post}</b>
          </span>
          {e.Reason_Title !== null ? (
            <p className="px-2 py-1 wp-text text-justify mb-0">
              علت درخواست: <b>{e.Reason_Title}</b>
              <br></br>
              <span className="wp-text-small text-muted">{e.Reason_Text}</span>
            </p>
          ) : null}
          {e.State_Title !== null ? (
            <span className="px-2 py-1 wp-text">
              وضعیت درخواست:{" "}
              <span className={e.State_CSS}>{e.State_Title}</span>
            </span>
          ) : null}
          {/* {e.WorkExpriences_Month !== null ? (
            <span className="bg-primary text-white px-2 py-1 wp-text">
              سابقه کار: {e.WorkExpriences_Month}
            </span>
          ) : null} */}
        </div>
        <div className="d-flex justify-content-end">
          {e.State === "1" ? (
            <div className="text-left">
              <button
                type="button"
                onClick={() => this.handleRequest(e.ID)}
                className="btn btn-danger btn-sm rounded-pill py-0 px-1 small-font"
              >
                لغو درخواست
              </button>
            </div>
          ) : null}
        </div>
        {e.State === "10" ? (
          <div className="text-justify mt-2">
            <div className="alert alert-warning p-2 rounded-0">
              {e.Description}
            </div>
            <div className="text-left">
              <button
                type="button"
                onClick={() => this.handleRequest(e.ID)}
                className="btn btn-danger btn-sm rounded-pill py-0 px-3 mx-1 small-font"
              >
                انصراف
              </button>
              <button
                type="button"
                onClick={() => this.handleSubmitRequest(e.ID)}
                className="btn btn-success btn-sm rounded-pill py-0 px-3 small-font"
              >
                تایید
              </button>
            </div>
          </div>
        ) : null}
        {e.State === "20" ? (
          <div className="text-justify mt-2">
            <div className="alert alert-danger p-2 rounded-0 mb-0">
              {e.Description}
            </div>
            <div className="my-1 text-danger">
              <span>مهلت تکمیل پرونده: </span> {e.DeadlineTime_Request}
            </div>
            <div className="text-left">
              <button
                type="button"
                onClick={() => this.handleRequest(e.ID)}
                className="btn btn-danger btn-sm rounded-pill py-0 px-3 mx-1 small-font"
              >
                انصراف از وام
              </button>
              <button
                type="button"
                onClick={() => this.handleSubmitRequest(e.ID)}
                className="btn btn-success btn-sm rounded-pill py-0 px-3 small-font"
              >
                تکمیل پرونده کردم
              </button>
            </div>
          </div>
        ) : null}
        {e.State === "16" ? (
          <div className="text-justify mt-2">
            <div className="alert alert-warning p-2 rounded-0 mb-1">
              {e.Description}
            </div>
            <div className="text-left">
              <button
                type="button"
                onClick={() => this.handleSubmitRequest(e.ID)}
                className="btn btn-success btn-sm rounded-pill py-0 px-3 small-font"
              >
                وام را دریافت کردم
              </button>
            </div>
          </div>
        ) : null}
      </li>
    ));
    if (this.state.isRegister === true) {
      return (
        <React.Fragment>
          <div className="w-100 body-padding">
            <p className="wp-header small">درخواست های ثبت شده قبلی</p>
            <ul className="Array p-0 mb-5">
              {myRequest.length === 0 ? (
                <li className="Array-item">
                  <div className="title">
                    هنوز درخواست تسهیلاتی توسط شما ثبت نشده است.
                  </div>
                </li>
              ) : (
                myRequest
              )}
            </ul>
            <button
              onClick={this.toggleRegister}
              className="btn btn-success wp-button-add"
            >
              <span>ثبت درخواست جدید</span>
            </button>
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div className="w-100 body-padding">
            <p className="wp-header">ثبت درخواست تسهیلات بانکی</p>
            <div className="row justify-content-center">
              <div className="col-6 mb-2">
                <label className="font-weight-bold">جایگاه سازمانی</label>
                <input
                  type="text"
                  defaultValue={this.thosandSeprator(
                    this.props.userLoanInfoJson.post_title
                  )}
                  className="form-control form-control-lg wp-input-text rounded-0 valid-empty ltr"
                  tabIndex="1"
                  disabled
                />
                <div className="invalid-feedback wp-text-small"></div>
              </div>
              <div className="col-6 mb-2">
                <label className="font-weight-bold">مدت سابقه (ماه)</label>
                <input
                  type="text"
                  defaultValue={this.thosandSeprator(
                    this.props.userLoanInfoJson.expriences
                  )}
                  className="form-control form-control-lg wp-input-text rounded-0 valid-empty ltr"
                  tabIndex="1"
                  disabled
                />
                <div className="invalid-feedback wp-text-small"></div>
              </div>
              <div className="col-12 mb-2">
                <label className="font-weight-bold">
                  سقف مبلغ قابل درخواست (ریال)
                </label>
                <input
                  type="text"
                  defaultValue={this.thosandSeprator(
                    this.props.userLoanInfoJson.amount
                  )}
                  className="form-control form-control-lg wp-input-text rounded-0 valid-empty ltr"
                  tabIndex="1"
                  disabled
                />
                <div className="invalid-feedback wp-text-small"></div>
                {this.props.userLoanInfoJson.describe !== null ? (
                  <div className="w-100 alert alert-warning wp-text-small rounded-0 p-2">
                    {this.props.userLoanInfoJson.describe}
                  </div>
                ) : null}
              </div>
              <div className="col-12 mb-2">
                <label className="font-weight-bold">
                  مبلغ درخواستی (ریال)
                  <span className="text-danger mr-1">*</span>
                </label>
                <input
                  type="text"
                  onKeyUp={() => this.thosandSepratorBlur("Amount")}
                  onBlur={() => this.HandleAmount("Amount")}
                  defaultValue="0"
                  id="Amount"
                  name="Amount"
                  className="form-control form-control-lg wp-input-text rounded-0 valid-empty ltr NumberValid"
                  tabIndex="1"
                />
                <div className="invalid-feedback wp-text-small"></div>
              </div>
              <div className="col-12 mb-2">
                <label className="font-weight-bold">
                  علت درخواست<span className="text-danger mr-1">*</span>
                </label>
                <select
                  id="Reason_ID"
                  name="Reason_ID"
                  type="text"
                  className="form-select form-select-lg text-center wp-input-text rounded-0"
                  placeholder="علت درخواست"
                  defaultValue=""
                >
                  <option value="">انتخاب نمایید</option>
                  {listLoanReasonItems_Active}
                </select>
              </div>
              <div className="col-12 mb-2">
                <label className="font-weight-bold">
                  شرح درخواست<span className="text-danger mr-1">*</span>
                </label>
                <textarea
                  id="Reason_Text"
                  name="Reason_Text"
                  rows="3"
                  className="form-control form-control-lg wp-input-text rounded-0"
                  placeholder="به صورت کامل علت درخواست خود را وارد نمایید."
                  defaultValue=""
                ></textarea>
                <div className="alert alert-info p-1 wp-text-small rounded-0">
                  حداقل 50 کاراکتر وارد نمایید.
                </div>
              </div>
              <div className="col-12 mb-2 text-center">
                <div className="bg-danger text-white w-100">
                  <label className="wp-text">تصویر درخواست کتبی</label>
                  <br />
                  <input
                    type="file"
                    id="inputDoc"
                    className="file"
                    accept="image/*, application/pdf"
                    onChange={() => this.handleFileSelect("inputDoc")}
                  ></input>
                  <label
                    htmlFor="inputDoc"
                    className="btn btn-light rounded-0 d-flex btn-sm file-lable"
                  >
                    انتخاب فایل...
                  </label>
                </div>
              </div>
              <div className="col-12 mb-2">
                <div className="form-check text-right">
                  <input
                    className="form-check-input lawCheckbox"
                    type="checkbox"
                    value="on"
                    id="flexCheckDefault"
                  ></input>
                  <label
                    className="form-check-label"
                    htmlFor="flexCheckDefault"
                  >
                    <a
                      href={LoanInformation}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      قوانین و مقررات
                    </a>{" "}
                    را مطالعه کردم و با آن موافق هستم.
                  </label>
                </div>
              </div>
              <div className="col-12 text-left">
                <button
                  onClick={this.toggleRegister}
                  className="btn btn-warning rounded-0"
                >
                  <span>بازگشت</span>
                </button>
                <button
                  id="SubmitForm"
                  className="btn dina-btn-blue rounded-0"
                  onClick={this.submitForm}
                >
                  <AiFillSave /> ثبت درخواست
                </button>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
  handleRequest = (e) => {
    this.props.declineLoanRequest(e);
  };
  handleSubmitRequest = (e) => {
    this.props.SubmitLoanRequest(e);
  };
  submitForm = () => {
    var amount = document.getElementById("Amount").value;
    amount = amount.toString().replace(/,/g, "");
    if (amount > 0) {
      if (parseInt(amount) <= parseInt(this.props.userLoanInfoJson.amount)) {
        var Reason_ID = document.getElementById("Reason_ID").value;
        if (Reason_ID !== null && Reason_ID !== "") {
          var Reason_Text = document.getElementById("Reason_Text").value;
          if (
            Reason_Text !== null &&
            Reason_Text !== "" &&
            Reason_Text.length >= 50
          ) {
            var chkLawBox = document.querySelector(".lawCheckbox:checked");
            if (chkLawBox !== null && chkLawBox.value === "on") {
              const token = localStorage.getItem("token");
              if (token !== null) {
                var formdata = new FormData();
                formdata.append("token", token);
                formdata.append("Amount", amount);
                formdata.append("Reason_ID", Reason_ID);
                formdata.append("Reason_Text", Reason_Text);

                var Reason_document = $("#inputDoc").prop("files")[0];
                if (Reason_document) {
                  if (Reason_document.size <= 10080000) {
                    formdata.append("Reason_Doc", Reason_document);
                  }
                }

                var requestOptions = {
                  method: "POST",
                  body: formdata,
                  redirect: "follow",
                };

                fetch(
                  `${process.env.REACT_APP_BASE_API_URL}/api/user/add-loan-request`,
                  requestOptions
                )
                  .then((response) => response.text())
                  .then((result) => {
                    if (result !== null) {
                      //this.props.toggleBlocking();
                      var myObject = JSON.parse(result);
                      if (myObject.status === 0) {
                        console.log("درخواست شما با موفقیت در سامانه ثبت شد.");
                        const errorMessage =
                          "درخواست شما با موفقیت در سامانه ثبت شد.";
                        this.props.toggleErrorMessage(errorMessage);
                        this.props.toggleError();
                        this.props.getUserLoanRequest();
                        this.setState({ isRegister: true });
                      } else {
                        const errorMessage = myObject.message;
                        this.props.toggleErrorMessage(errorMessage);
                        this.props.toggleError();
                      }
                    }
                  })
                  .catch((error) => console.log("error", error));
              } else {
                const errorMessage =
                  "مجدد وارد سامانه شوید، نشست شما به پایان رسیده است.";
                this.props.toggleErrorMessage(errorMessage);
                this.props.toggleError();
              }
            } else {
              const errorMessage = "قوانین و مقررات را مطالعه و تایید نمایید.";
              this.props.toggleErrorMessage(errorMessage);
              this.props.toggleError();
            }
          } else {
            const errorMessage =
              "شرح درخواست خود را به صورت کامل (حداقل 50 کاراکتر) وارد نمایید.";
            this.props.toggleErrorMessage(errorMessage);
            this.props.toggleError();
          }
        } else {
          const errorMessage = "علت درخواست خود را انتخاب نمایید.";
          this.props.toggleErrorMessage(errorMessage);
          this.props.toggleError();
        }
      } else {
        const errorMessage = "مبلغ وارد شده بیش از حد مجاز است.";
        this.props.toggleErrorMessage(errorMessage);
        this.props.toggleError();
      }
    } else {
      const errorMessage = "مبلغ تسهیلات مورد نظر خود را وارد نمایید.";
      this.props.toggleErrorMessage(errorMessage);
      this.props.toggleError();
    }
  };
}
export default Refahi;
